import axios from "axios";
import { getToken } from "../services/tokenStore";

const API_BASE_URL = `${(
  process.env.REACT_APP_API_URL ||
  'https://backend-clinical-intake.dizzaroo.com'
).replace(/\/$/, '')}/api`;

console.log("API Base URL:", API_BASE_URL); // Debugging

const axiosInstance = axios.create({
    baseURL: API_BASE_URL,
    timeout: 1200000,
    headers: {
        'Content-Type': 'application/json'
    }
});

const LONG_RUNNING_AI_PATHS = [
    '/validate-documents',
    '/auto-populate-admin-and-trial-schema',
    '/process-source-documents',
    '/source-documents/jobs',
];

const isAiRequest = (url = '') => url.includes('/ai/') || url.includes('/api/ai');

// Add a request interceptor
axiosInstance.interceptors.request.use(
    (config) => {
        const token = getToken();
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }

        const url = config.url || '';
        const isLongRunning = LONG_RUNNING_AI_PATHS.some((path) => url.includes(path));

        if (isLongRunning) {
            config.timeout = Math.max(config.timeout || 0, 600000);
        } else         if (isAiRequest(url)) {
            config.timeout = Math.max(config.timeout || 0, 300000);
        }
        if (url.includes('/s9/')) {
            config.timeout = Math.max(config.timeout || 0, 600000);
        }
        if (config.url.includes('/validation/sync-to-knowledge-graph-with-embeddings')) {
            // Only override if not already set (allows per-request override)
            if (!config.timeout || config.timeout === 1200000) {
                config.timeout = 6000000; // 10 minutes for embeddings sync
                console.log('🔧 Setting extended timeout for embeddings sync: 600 seconds (10 minutes)');
            }
        }
        
        // Set longer timeout for entity extraction
        if (config.url.includes('/validation/extract-entities')) {
            // Only override if not already set (allows per-request override)
            if (!config.timeout || config.timeout === 1200000) {
                config.timeout = 3000000; // 5 minutes for entity extraction
                console.log('🔧 Setting extended timeout for entity extraction: 300 seconds (5 minutes)');
            }
        }
        
        // Set longer timeout for ADK workflow approval (execution phase)
        if (config.url.includes('/adk/workflow/approve')) {
            // Only override if not already set (allows per-request override)
            if (!config.timeout || config.timeout === 1200000) {
                config.timeout = 6000000; // 10 minutes for approval and execution
                console.log('🔧 Setting extended timeout for section approval: 600 seconds (10 minutes)');
            }
        }
        
        // Set longer timeout for ADK workflow modification (planning phase)
        if (config.url.includes('/adk/workflow/modification')) {
            // Only override if not already set (allows per-request override)
            if (!config.timeout || config.timeout === 1200000) {
                config.timeout = 3000000; // 5 minutes for planning phase
                console.log('🔧 Setting extended timeout for workflow planning: 300 seconds (5 minutes)');
            }
        }
        return config;
    },
    (error) => {
        console.error('Request interceptor error:', error);
        return Promise.reject(error);
    }
);

// Add a response interceptor
axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.code === 'ECONNABORTED') {
            console.error('Request timeout:', error);
            return Promise.reject(new Error('Request timed out. Please try again.'));
        }
        if (!error.response) {
            console.error('Network error:', error);
            return Promise.reject(new Error('Network error. Please check your connection.'));
        }
        console.error('API error:', error.response);
        return Promise.reject(error);
    }
);

export default axiosInstance;
